import { useContext } from "react"
import ConfigurationContext from "../context/ConfigurationContext.js"
import Translation from "../i18n/Translation.js"
import style from "../style/LandingSteps.module.css"

type Properties = Readonly<{}>

/**
 * @description
 *	The 3 (three) steps of the verification, iconified. The icons are
 *	decorative: every step is already readable as text.
 */
export default function LandingSteps({}: Properties) {
	const displayText = Translation[useContext(ConfigurationContext).DEFAULT_LOCALE]
	return (
		<ol className={style["landing-steps"]}>
			<li className={style["landing-step"]}>
				<span aria-hidden="true" className={style["landing-step-icon"]}>
					<svg
						fill="none"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.8"
						viewBox="0 0 24 24"
					>
						<rect height="13" rx="3" width="18" x="3" y="7" />
						<path d="M9 7l1.2-2.2h3.6L15 7" />
						<circle cx="12" cy="13.5" r="3.5" />
					</svg>
				</span>
				{displayText.landingStepCamera}
			</li>
			<li className={style["landing-step"]}>
				<span aria-hidden="true" className={style["landing-step-icon"]}>
					<svg
						fill="none"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.8"
						viewBox="0 0 24 24"
					>
						<ellipse cx="12" cy="12" rx="6.5" ry="8.5" />
						<circle cx="12" cy="10" r="2.6" />
						<path d="M7.6 18.2c.9-2 2.5-3 4.4-3s3.5 1 4.4 3" />
					</svg>
				</span>
				{displayText.landingStepOval}
			</li>
			<li className={style["landing-step"]}>
				<span aria-hidden="true" className={style["landing-step-icon"]}>
					<svg
						fill="none"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.8"
						viewBox="0 0 24 24"
					>
						<circle cx="12" cy="12" r="8.5" />
						<path d="M12 7.5V12l3 1.8" />
					</svg>
				</span>
				{displayText.landingStepHold}
			</li>
		</ol>
	)
}
